const locale = {
    placeholder: 'Aukeratu ordua',
};
export default locale;
